import { takeLatest, put, call } from 'redux-saga/effects';

import { listClienteCadastro } from '../service';
import {
  TABLE_CLIENTE_CADASTRO,
  TABLE_CLIENTE_CADASTRO_PENDING,
  TABLE_CLIENTE_CADASTRO_SUCCESS,
  TABLE_CLIENTE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListClienteCadastro(action) {
  yield put({ type: TABLE_CLIENTE_CADASTRO_PENDING })

  try {
    const table = yield call(listClienteCadastro, action.args)
    yield put({ type: TABLE_CLIENTE_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CLIENTE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListClienteCadastro() {
  yield takeLatest(TABLE_CLIENTE_CADASTRO, sagaListClienteCadastro)
}